import omitBy from 'lodash/omitBy';
import isUndefined from 'lodash/isUndefined';
import {SettingsParamsType, StoreSettings} from '../models/storeSettings';

const settingsSerializer = (
  pendingSettings: StoreSettings
): SettingsParamsType => {
  const output = JSON.parse(
    JSON.stringify({
      name: pendingSettings.name,
      url_slug: pendingSettings.urlSlug,
      campaign_closes_at: pendingSettings.campaignClosesAt,
      delivery_strategy: pendingSettings.deliveryStrategy,
      payment_strategy: pendingSettings.paymentStrategy,
      autofulfill: pendingSettings.autofulfill,
      enable_order_placed_email: pendingSettings.enableOrderPlacedEmail,
      group_note: pendingSettings.groupNote,
      delivery_note: pendingSettings.deliveryNote
    })
  );
  return {
    ...omitBy(output, isUndefined)
  };
};

export default settingsSerializer;
